import { API, Book, BookAPI, Designer, Lang, Project, PageModel, ProjectAPI, Tag, UploadFileAPI, ProjectUtils, Endpoints, CurrencyType } from "@brg/api";
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { useProfile } from "@brg/auth";
import { Colors, FInter, FlexBox, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { bTag, LayoutConst, useModal } from "core";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import { CreateLinkTo } from "shared/constants/linkTo";
import { convertDesignerFromGlobalToLocal } from "shared/pages/projectEdit/utils";
import { createPortal } from "react-dom";
import { NavbarCreate } from "shared/components/navbar-elements";
import { BookEditFrameCreating, BookEditFrameError, BookEditFrameForbidden, BookEditFrameLoading, BookEditFrameUpdateError } from "_deziiign/books/core/components/error-frames/book-edit-frames";
import { PageViewportLayout, ProjectContainerLayout } from "shared/components/template";
import { ScrollUpZone } from "shared/components/__FOX__/NAV/src/scroll-up-zone";
import { ProjectEditPageContainer, ProjectEditPageGrid, ProjectEditPageGridLabel, ProjectEditPageGridRow } from "shared/pages/projectEdit/styles";
import ProjectTitleSection from "shared/pages/projectEdit/ProjectTitleSection";
import { LabelRedStar, QueueButtonFilled} from "shared/pages/designerEditView/styles";
import { BTag } from "core/components";
import styled, { useTheme } from "styled-components";
import { BookDelegate } from "_deziiign/books/core/book-delegate";
import { BookEditAddTagsContainer, BookTitleSectionOuter } from "./styles";
import { BookChaptersEdit } from "./BookChaptersEdit/BookChaptersEdit";
import { BookImageContainer } from "./BookChaptersEdit/BookImageContainer";
import { useSimpleUploader } from "@brg/uploader";
import axios, { AxiosResponse } from "axios";
import {BookCards} from "./components/BookCards/BookCards";
import {
    useGetAdditionalBookItems,
} from "../../../../shared/hooks/api/Shop/useGetAdditionalItems";
import {QueueMode, QueueNew} from "../../../../shared/features/QueuePaymenrt/components/Queue/New/QueueNew";
import {
    QueueCircleType,
    QueueRate
} from "../../../../shared/features/QueuePaymenrt/components/Queue/New/components/QueueLineNew/QueueLineNew";
import {
    clearOrderFields,
    goToStep, selectorOrder,
    setFlowType,
    setImmediatePurchaseProps
} from "../../../../shared/features/QueuePaymenrt/slices/OrderSlice";
import {FlowType} from "../../../../shared/features/QueuePaymenrt/constants/flowType";
import {useDispatch, useSelector} from "react-redux";
import {EntityPaymentTypes} from "../../../../shared/features/QueuePaymenrt/constants/payment";
import {bookFlowSteps } from "../../../../shared/features/QueuePaymenrt/payment/Flows";
import {Input} from "@brg/input";
import {BilingLabel, BilingWrapper} from "../../../../shared/pages/projectEdit/styles";
import {useBookCard} from "../../../../shared/hooks/api/Book/useBookCard";
import {UpsertBookData} from "../../../../shared/actions/Book/UpsertBookData";
import { Availability } from "shared/pages/projectEdit/components/Availability/Availability";
import { AvailabilityAction } from "shared/pages/projectEdit/types";
import { copyLinkProject } from "shared/helpers/copyLink";
import { ProtectSection } from "./sections/ProtectSection";
import { protectStatuses } from "shared/helpers/protectStatus";
import {BTagsGridNew} from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import Unavailable from "shared/pages/unavailable";
import { DRAFT_STATUS } from "shared/pages/projectEdit/constants";

const MAX_FILE_SIZE = 157286400;

const ChaptersWrapper = styled(FlexBox)`

    @media (max-width: ${LayoutConst.screen.mac13 + 1}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin: 24px auto;
        width: 888px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      justify-content: center;
        //margin: 16px 6.6vw 0;
        margin: 16px 0 0 0;
        width: auto;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        margin: 24px 10px 0;
    }
`;

const SectionBottom = styled(FlexBox)`
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const ErrorItem = styled(FInter.SmallTextFlex)`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  display: flex;
  align-items: baseline;
  color: #909090;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`;

const RequiredErrorMsg = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #909090;
  white-space: nowrap;
  padding-left: 4px;
`;

enum DnDHelp {
    Initialization = "INITIALIZATION",
    Wait = "WAIT",
    Showed = "SHOWED"
}

export enum PaymentStatus {
    Free = 0,
    PayBook = 1,
}

interface MobileInputsState {
    coAuthor: boolean;
    publisher: boolean;
    bibliography: boolean;
}

interface BookEditProps {
    className?: any;
}

const BOOK_DRAFT_TAB_POSTFIX = "?tab=draft_books"

export const MINIMUM_CARDS_FOR_QUEUE = 1

export const BookEdit: FC<BookEditProps> = ({ className }) => {
    const { t, i18n } = useTranslation();
    const toasts = useToasts();
    const profile = useProfile();
    const { id } = useParams<{ id: string }>();
    const throttle = useRef<any>();
    const history = useHistory();
    const isMobile = useIsMobile();
    const modal = useModal();
    const theme = useTheme();
    const dispatch = useDispatch();
    
    const [isCreating, setIsCreating] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isForbidden, setIsForbidden] = useState(false);
    const [isUpdateError, setIsUpdateError] = useState(false);
    const { activeTariff } = useSelector(selectorOrder)

    const [isChaptersUpdateLoading, setIsChaptersUpdateIsLoading] = useState<boolean>(false);
    const [isCardsUpdateLoading, setIsCardsUpdateIsLoading] = useState<boolean>(false);
    const isPaymentUpdateLoading = useMemo(() => isCardsUpdateLoading || isChaptersUpdateLoading, [isCardsUpdateLoading, isChaptersUpdateLoading])

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isHiddenLoading, setIsHiddenLoading] = useState<boolean>(false);
    const [isBookForSale, setIsBookForSale] = useState<boolean>(false);
    const [isPaymentTypeLoading, setIsPaymentTypeLoading] = useState<boolean>(false);
    const [time, setTime] = useState(Date.now());
    const [book, setBook] = useState<Book<'Global'> & any>();
    const [bookTitle, setBookTitle] = useState<LangObject[]>([]);
    const [bookCoAuthors, setBookCoAuthors] = useState<Designer[]>([]);
    const [bookTags, setBookTags] = useState<Tag[]>([]);
    const [chaptersTags, setChaptersTags] = useState<Tag[]>([])
    const [bibliography, setBibliography] = useState<string>("");
    const [publisher, setPublisher] = useState<string>("");
    const [bookStatus, setBookStatus] = useState<number>(0);
    const [isAllChaptersPublished, setIsAllChaptersPublished] = useState<boolean>(false);
    const [chapters, setChapters] = useState<Project[]>([]);
    const [chapterIds, setChapterIds] = useState<string[]>([]);
    const [chapterLongreadsPostCount, setChapterLongreadsPostCount] = useState<number[]>([]);
    const [isTooltipShowed, setIsTooltipShowed] = useState(false);
    const [availability, setAvailability] = useState<string>(AvailabilityAction.open);
    // @ts-ignore
    const chapterHasCover = useCallback((chapter) => !!ProjectUtils.getTitleImageOrUndefined(chapter), [chapters]);
    const [activeCardIds, setActiveCardIds] = useState<string[]>([]);
    const [isProtected, setIsProtected] = useState(false);
    const isPaidBook = useMemo(() => BookDelegate.isPaid(book), [book])

    const [additionalItems] = useGetAdditionalBookItems(id, isPaidBook, time)
    useEffect(() => {
        setActiveCardIds(additionalItems?.filter((item: any) => item?.isForPay && item?.printQuality !== 'A5')?.map((item: any) => item?.itemId))
    }, [additionalItems])
    useEffect(() => {
        setIsBookForSale(book?.paymentType === PaymentStatus.PayBook)
        setIsPaymentTypeLoading(false)
    }, [book?.paymentType])

    const onChaptersAdd = useCallback((chapters: any) => {
        setChapters(chapters)
    } , [])

    const bookAndChaptersTags = useMemo(() => {
        const uniqueMap = new Map<string, Tag>();
        [...bookTags, ...chaptersTags].forEach((item) => {
          uniqueMap.set(item.tagId, item);
        });
        return Array.from(uniqueMap.values());
    } , [bookTags, chaptersTags, isLoading])

    const errorsArray = useMemo(() => {
        const errors = [];

        if (isLoading && !isHiddenLoading) return []

        if (chapters.length === 0) {
            errors.push(t('create.tips.book_no_chapters'));
        }

        let uncompletedChapters: number[] = []

        chapters.forEach((chapter, idx) => {
            if (chapter.title.length === 0 || !chapterHasCover(chapter) || chapter.tagsID.length === 0 || chapterLongreadsPostCount[idx] === 0) {
                uncompletedChapters.push(idx+1)
            }
        })

        if (uncompletedChapters.length > 0) {
            if (uncompletedChapters.length > 1) {
                errors.push(t('create.tips.book_chapters_uncomplete', {
                    chapters: uncompletedChapters.join(", ")
                }));
            } else {
                errors.push(t('create.tips.book_chapter_uncomplete', {
                    chapter: uncompletedChapters[0]
                }));
            }
        }

        if (Lang(bookTitle, i18n.language).replaceAll(" ", "").length === 0 || bookAndChaptersTags.length === 0) {
            errors.push(t('create.tips.fill'))
        }

        if (!bookAndChaptersTags.find((tag) => tag.isEducationTag)) {
            errors.push(t('create.tips.educational_tags_not_enough'));
        }

        return errors;
      }, [chapters, chapterIds, bookTitle, i18n, isLoading, isHiddenLoading, bookAndChaptersTags, chapterLongreadsPostCount])

    const inputsRef = useRef<any>(null);
    
    const [inputsState, setInputsState] = useState<MobileInputsState>({
        coAuthor: false,
        publisher: false,
        bibliography: false
    })

    const [statusText, setStatusText] = useState('');
    const [isSending] = useState(false);
    const [statusDnDHelp, setStatusDnDHelp] = useState<DnDHelp>(DnDHelp.Initialization); 

    const projectIdRef = useRef<any>(null);
    const langRef = useRef<any>(null);
    const bilingualRef = useRef<any>(null);
    const sipRef = useRef<any>(null);
    const sipRefEn = useRef<any>(null);

    projectIdRef.current = id;

    const primaryButtonText = useMemo(() => (
        bookStatus === 0
            ?   t('nav.publish')
            :   t('save')
    ), [bookStatus, t]);

    const previewProject = useMemo(() => (chapters?.length > 0 && chapters?.[0]), [chapters])

    const fetchLongreadsPostCount = async () => {
        const longreadsPostCount = await Promise.all(chapterIds.map(async (chapterId) => {
            const longreadPosts: AxiosResponse<any[]> = await axios.get(`${Endpoints.longread}/api/post/GetMany?idLongread=${chapterId}`)
            return longreadPosts.data.length
        }))
        setChapterLongreadsPostCount(longreadsPostCount)
        return longreadsPostCount
    }

    const onUpdatePaymentType = useCallback((isBookForSale: boolean) => {

        if (isPaymentTypeLoading) return;

        setIsPaymentTypeLoading(true)
        API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/Book/UpdatePaymentType`)
            .post()
            .body({
                bookId: book?.bookId,
                paymentType: isBookForSale ? PaymentStatus.PayBook : PaymentStatus.Free,
            })
            .send()
            .then(() => {
                setIsBookForSale(isBookForSale)
                setIsPaymentTypeLoading(false)
            });
    }, [book, isPaymentTypeLoading]);

    const bookCards = useMemo(() => additionalItems?.filter((item: any) => activeCardIds?.includes(item?.itemId)) || [], [additionalItems, activeCardIds])

    const {
        cardId: bookCardId,
        isLoading: isBookCardLoading,
        error: bookCardError
    } = useBookCard(book?.bookId || "", !isBookForSale || isLoading || isHiddenLoading)

    const handleLinkCopy = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        copyLinkProject(book?.bookId, toasts, t);
    };


    useEffect(() => {
        fetchLongreadsPostCount()
    }, [chapterIds])
    useEffect(() => {
        UpsertBookData(book?.bookId || "", { chapterIds }, setIsChaptersUpdateIsLoading, dispatch)
    }, [book?.bookId, chapterIds])

    useEffect(() => {
        if (profile) {
            if (id) {
                BookAPI.Get({ id: id })
                    .then((value) => value.json() as Promise<Book<'Global'>>)
                    .then((value) => {
                        if (value.bookId) {
                            setBook(value);
                            setIsError(false);
                            const projectAvailability = value.status === 10 ? AvailabilityAction.link : AvailabilityAction.open;
                            setAvailability(projectAvailability);
                            if (!BookDelegate.canEdit(profile, value)) {
                                setIsForbidden(true);
                            }
                        } else {
                            setBook(undefined);
                            setIsError(true);
                        }
                    })
                    .catch((reason) => {
                        setBook(undefined);
                        setIsError(true);
                    });
            } else {
                setIsCreating(true);
                BookAPI.Add({
                        title: createDefaultLangObject(''),
                        status: 0
                    } as Book<'Global'> & any)
                    .then((res) => res.json())
                    .then((res: any) => {
                        setTimeout(() => {
                            setIsCreating(false);
                            history.replace(CreateLinkTo.bookEdit(res));
                        }, 800);
                    });
            }
        }
    }, [id, profile, history, time]);

    useEffect(() => {
        if (profile && book && book.bookId) {
            setBookTitle(book.title);
            setBookStatus(book.status);
        }
    }, [profile, book])

    useEffect(() => {
        if (profile && book && book.bookId) {

            const coAuthors = (book.coAuthors || []) as Designer<'Global'>[];

            setBookCoAuthors(coAuthors.map((author) => convertDesignerFromGlobalToLocal(author, i18n.language)));

            const currentTags = [...book.tags].map((tag) => {
                const translatedTag = API.toLang<Tag>(tag, i18n.language);
                return {
                    ...translatedTag,
                }
            });

            setBookTags(currentTags);

            setBibliography(book.bibliographyLink);
            setPublisher(book.publisher);

            setIsProtected(book.isProtected)
        }

    }, [profile, book]);

    useEffect(() => {
        if (book && book.bookId) {
            if (throttle.current) {
                clearTimeout(throttle.current);
                throttle.current = null;
            }

            setStatusText(t('saving'));

            throttle.current = setTimeout(() => {
                if (book && book.bookId) {
                    const copy: Book<'Global'> = { ...book };

                    copy.title = bookTitle;
                    copy.coAuthorIds = bookCoAuthors.map((value) => value.accountId);
                    copy.tagIds = bookAndChaptersTags.map((value) => value.tagId);
                    copy.bibliographyLink = bibliography;
                    copy.publisher = publisher;

                    copy.isProtected = isBookForSale ? true : isProtected

                    BookAPI.Update(copy)
                        .then(() => {
                            setTimeout(() => setStatusText(t('saved')), 1000);
                            if (isSending) {
                                history.push(CreateLinkTo.book(book.bookId));
                            }
                        })
                        .catch(() => setIsUpdateError(true));
                }
            }, 1000);
        } else {
            setStatusText('Loading book...');
        }
    }, [
        history,
        isSending,
        profile,
        chapters,
        book,
        bookTitle,
        isProtected,
        isBookForSale,
        bookCoAuthors,
        bookAndChaptersTags,
        bookStatus,
        bibliography,
        publisher,
        id,
        t,
    ]);

    useEffect(() => {
        if (inputsState?.publisher || inputsState?.bibliography ) {
          inputsRef?.current?.focus()
        }
      },[inputsState])
    
      useEffect(() => {
        if (book) {
            setIsLoading(true);
            ProjectAPI.GetList({
                    bookId: book?.bookId,
                    projectFilter: 8,
                    isLite: false,
                    isContextIgnored: true
                })
                .then(v => v.json())
                .then((v) => API.toLang<PageModel<Project>>(v, i18n.language))
                .then((v) => {
                    let count = 0;
                    if (v?.data) {
                        count = v.data.length;
                        setChapters(v.data);
                        setIsTooltipShowed(v.data?.length >= 2);
                        setChapterIds(v.data.map(x => x.projectId));
                        setIsAllChaptersPublished(count > 0 && !v.data.some(x => x.status !== 1 && x.status !== 6));
                        const allTags = v.data.flatMap(x => x.tags);
                        const exptCategoryTags = allTags?.filter((i) => i?.level === 0);
                        setChaptersTags(exptCategoryTags);
                        
                    } else {
                        setChapters([]);
                        setChapterIds([]);
                        setIsAllChaptersPublished(false);
                    }
                    setIsLoading(false);
                    setIsHiddenLoading(false);
    
                    switch (statusDnDHelp) {
                        case DnDHelp.Initialization:
                            setStatusDnDHelp(count >= 2 ? DnDHelp.Showed : DnDHelp.Wait);
                            break;
                        case DnDHelp.Wait:
                            if (count >= 2) {
                                setStatusDnDHelp(DnDHelp.Showed);
                            }
                            break;
                        default:
                            break;
                    }
                });
        }
    }, [book, time, i18n]);

    const getRedirectIfBackClick = useCallback(() => {

        const moveToDrafts = !chapterIds?.length || 
            !chapterLongreadsPostCount?.length ||
            bookTitle?.every((i) => i.name === '') || 
            !bookAndChaptersTags?.length ||
            !bookAndChaptersTags?.find((i) => i?.isEducationTag) ||
            !!errorsArray?.length
        ;
            
        if (moveToDrafts) {
             BookAPI.UpdateStatus({
                bookStatus: DRAFT_STATUS,
                bookId: book?.bookId,
            })
        }

        profile && book && book.status === 0
            ? history.push(CreateLinkTo.designerNew(profile) + BOOK_DRAFT_TAB_POSTFIX)
            : history.replace(CreateLinkTo.book(book?.bookId ?? "undefined"))
    }, [book, history, profile, bookTitle, errorsArray, chapterIds, chapterLongreadsPostCount,  bookAndChaptersTags]);

    const updateChaptersProtectStatus = useCallback( async(ids: string[]) => {
        return await Promise.all(ids?.map(async(id) => (
            await API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/Project/Protect`)
            .post()
            .body({
              projectId: id ?? '',
              action: protectStatuses[isProtected? 'enabled' : 'disabled']
            })
            .send()
        )))
    } , [isProtected])

    const onPublish = useCallback((): void => {
        // получаем актуальные данные о главах
        if (profile && book) {
            ProjectAPI.GetList({
                bookId: book?.bookId,
                projectFilter: 8,
                isLite: false,
                isContextIgnored: true
            })
            .then(v => v.json())
            .then((v) => API.toLang<PageModel<Project>>(v, i18n.language))
            .then(async (v) => {
                const chapterLongreadsPostCount = await fetchLongreadsPostCount()
                return {
                    chapters: v.data,
                    chapterLongreadsPostCount
                }
            })
            .then(info => {
                const canPublish = BookDelegate.canPublish(profile, book, Lang(bookTitle, i18n.language), bookAndChaptersTags, info.chapters, info.chapterLongreadsPostCount);

                if (canPublish) {
                    setStatusText(t('save'));
                    BookAPI.UpdateStatus({
                        bookStatus: availability === AvailabilityAction.link ? 10 : 1,
                        bookId: id,
                    }).then(() => {

                        if (!!info.chapters?.length) {
                            updateChaptersProtectStatus(
                                info.chapters?.map((chapter) => chapter?.projectId)
                            )
                            .then((r) => {
                                if (r?.every((response) => !!response?.ok)) {
                                    history.push(CreateLinkTo.book(book.bookId));
                                } else {
                                    toasts.error(t("book_edit.chapters_updated_error"))
                                }
                            })  
                        } else {
                            history.push(CreateLinkTo.book(book.bookId));
                        }

                    });
                } else {
                    toasts.error(t("book_edit.chapters_updated_error"))
                }
            })
        }
    }, [history, id, profile, book, t, chapters, bookTitle, bookAndChaptersTags, availability, chapterLongreadsPostCount, isProtected]);


    const onProtectAfterPayment = useCallback(() => {
        if (!!chapterIds?.length) {
            updateChaptersProtectStatus(chapterIds)  
        } 
    } , [chapterIds, isProtected])

    const goToSuccess = useCallback(() => {
        modal.hide()
        onProtectAfterPayment()
        modal.show("bookPaymentSuccess", {
            products: [book],
            containerStyles: {
                background: 'rgba(231,231,231, 0.90)',
                backdropFilter: 'none'
            },
            onCustomClose: () => {
                window.open(CreateLinkTo.book(book?.bookId), '_SELF');
            }
        })
    }, [modal, book, onProtectAfterPayment])

    const openPaymentModal = useCallback(async () => {
        try {
            if (!profile) {
                toasts.error("You need to login")
                return
            }
            if (!book?.bookId) return
            const translatedBook = API.toLang(book, i18n.language) as Book<'Local'>;

            await dispatch(setFlowType(FlowType.BUY_BOOK))
            dispatch(setImmediatePurchaseProps({
                productId: bookCardId,
                paymentEntityType: EntityPaymentTypes.book,
                flowType: FlowType.BUY_BOOK,
                currencyType: CurrencyType.RealMoney,
                preventGetCurrencies: true,
                tariff: activeTariff,
                bookId: book?.bookId,
                price: activeTariff?.creatingPrice || 0,
                productInfo: {
                    name: bookTitle || translatedBook?.title || "",
                    // @ts-ignore
                    preview: previewProject?.titleImages || translatedBook?.titleImages,
                    price: activeTariff?.creatingPrice || 0,
                    type: EntityPaymentTypes.book,
                    cardInfo: bookCards
                }
            }))
            modal.show("paymentManager", {
                containerStyles: {
                    background: 'rgba(231,231,231,1)',
                    backdropFilter: 'none'
                },
                flowType: FlowType.BUY_BOOK,
                onPaymentSuccess: () => goToSuccess(),
                onPaymentFail: () => {
                    dispatch(goToStep(bookFlowSteps.errorPayment)) },
                cancel: () => { dispatch(clearOrderFields()) },
            })
        } catch (err) {
            toasts.error(`${t('messages.something_went_wrong')}. ${t('try_later')}.`)
            console.error('openPaymentModal err:', err);
        }
    }, [dispatch, book, activeTariff, activeCardIds, goToSuccess, bookCardId, bookCards, previewProject])

    const previewButtonClick = useCallback(() => history.push(CreateLinkTo.bookPreview(id)), [history, id]);
    const isReadyToPublish = useMemo(() => BookDelegate.canPublish(profile, book, Lang(bookTitle, i18n.language), bookAndChaptersTags, chapters, chapterLongreadsPostCount), [profile, book, bookTitle, i18n.language, bookAndChaptersTags, chapters, chapterLongreadsPostCount])
    const isPaymentButtonDisabled = useMemo(() => (activeTariff?.creatingPrice === 0 || isBookCardLoading || isPaymentUpdateLoading || isSending || activeCardIds?.length < MINIMUM_CARDS_FOR_QUEUE || !isBookForSale || !isReadyToPublish || !BookDelegate.canChangePaymentType(book)), [activeTariff, isBookCardLoading, isSending, isReadyToPublish, isBookForSale, activeCardIds, book, isPaymentUpdateLoading])

    const PortalMenu = useMemo(() => {
        const outer = document.getElementById('navbar-portal');
        if (!outer) {
            return null;
        }

        return createPortal(
            <NavbarCreate
                className={className}
                status={bookStatus}
                isReadyToNext={!isSending}
                primaryButtonEnabled={(isBookForSale && bookStatus !== 1) ? !isPaymentButtonDisabled : isReadyToPublish}
                primaryButtonText={primaryButtonText}
                projectName={Lang(bookTitle, i18n.language)}
                stateText={statusText}
                onSecondaryClick={getRedirectIfBackClick}
                onPrimaryClick={(isBookForSale && bookStatus !== 1) ? openPaymentModal : onPublish}
                onPreviewClick={previewButtonClick}
                errors={errorsArray}
            />,
            outer,
        );
    }, [
        chapters,
        profile,
        className,
        bookTitle,
        bookAndChaptersTags,
        errorsArray,
        chapterLongreadsPostCount,
        statusText,
        bookStatus,
        isBookForSale,
        isReadyToPublish,
        isPaymentButtonDisabled,
        openPaymentModal,
        onPublish,
        getRedirectIfBackClick,
        previewButtonClick,
        i18n,
        primaryButtonText,
        isSending,
    ]);

    const onTitleChange = (value: string) => {
        setBookTitle(createDefaultLangObject(value));
    }

    const getBookStatus = useCallback((): number => {
        return bookStatus;
    }, [bookStatus]);

    const getBookAuthorIds = useCallback((): string[] => {
        if (book && book.authorId) {
            return [ ...bookCoAuthors.map(x => x.accountId), book.authorId ];
        }
        return bookCoAuthors.map(x => x.accountId);
    }, [book, bookCoAuthors]);

    const canCreateChapter = useMemo(() => {
        const bookStatus = getBookStatus();
        return bookStatus !== 1 && bookStatus !== 6 && statusText === t('saved')
    }, [getBookStatus, statusText, t]);

    const onCreateChapterClick = useCallback(() => {
        if (!canCreateChapter) {
            return;
        }
        history.push(CreateLinkTo.bookProjectCreate(book?.bookId));
    }, [book, history, canCreateChapter]);

    const onChapterDelete = useCallback((projectId: string) => {
        ProjectAPI.RemoveBookInfo({
                bookChapterNumber: 0,
                bookId: book?.bookId,
                projectId: projectId,
            })
            .then(() => {
                setTime(Date.now());
            });
    }, [book]);


    const onChapterAdd = useCallback((projectId: string, isFirst?: boolean, isMultiple?: boolean) => {
        ProjectAPI.AddBookInfo({
                bookChapterNumber: 0,
                bookId: book?.bookId,
                projectId: projectId,
            })
            .then(() => {
                if ((chapters?.length >= 1 || isMultiple) && isFirst && !isTooltipShowed) {
                    setIsTooltipShowed(true);
                    toasts.info(t('book_edit.chapters.dnd_info'));
                }
                setTime(Date.now());
            });
    }, [book, chapters, isTooltipShowed]);

    const onSelectChaptersClick = useCallback(() => {
        if (isPaidBook) return;

        const chapterIds = chapters?.filter((i) => {
            return i?.authorId === profile?.accountId || i?.coAuthorIds?.includes(profile?.accountId ?? '')
        })
        modal.show('select-chapters', {
            projectIds: chapterIds?.map((i) => i?.projectId),
            authorsIds: profile?.accountId,
            bookStatus: getBookStatus(),
            bookId: book?.bookId,
            onSelect: onChapterAdd,
            onUnSelect: onChapterDelete
        });
    }, [modal, book, profile, chapters, getBookAuthorIds, getBookStatus, onChapterAdd, onChapterDelete, isPaidBook]);

    const handleToggleProtectTypeClick = useCallback((val: boolean) => {
        if (isBookForSale) {
            toasts.error(t('book_edit.frames.book_default_protect'));
            return;
        }

        setIsProtected(val)
    } , [isBookForSale, toasts])

    // @ts-ignore
    const uploaderCallback = useCallback((fileId) => {
        if (!fileId) {
          return null;
        }
    
        UploadFileAPI.Upload({
          fileId,
          profileId: projectIdRef.current,
          service: 'geography',
          entityType: 'projectimage',
          ...(bilingualRef.current === true ? {
            localization: langRef.current,
          } : {})
        }).then((res) => {
          sipRef.current.uploader.uploader.uppy.reset();
          return res;
        });
      }, [projectIdRef])
      const uploadValidator = useCallback(async (files: any) => {
        let failedChecks: {
          dimensions?: boolean;
          size?: boolean;
          ratio?: boolean;
          type?: boolean;
        } = {};
        const loadFile = () => new Promise((resolve, reject) => {
          const fr = new FileReader();
          fr.onload = function () { // file is loaded
            const img = new Image();
    
            img.onload = function () {
              const {
                width,
                height,
              } = img;
              resolve({
                width,
                height,
              })
            };
    
            //@ts-ignore
            img.src = fr.result; // is the data URL because called with readAsDataURL
          };
          fr.readAsDataURL(files[0]);
        })
    
        //@ts-ignore
        const { height, width } = await loadFile();
    
        if (height > 5262 || width > 3720) {
          toasts.error(t('project_edit.image_error.max_width_height'));
          failedChecks.dimensions = true;
        }
    
        const ratio = width / height;
        if (ratio < 0.6 || ratio > 0.8) {
          toasts.error(t('project_edit.image_error.wrong_orientation'));
          failedChecks.ratio = true;
        }
    
        if (files?.[0]?.size > MAX_FILE_SIZE) {
          toasts.error(t('project_edit.image_error.max_size'));
          failedChecks.size = true;
        }
    
        if (!['image/jpeg'].includes(files?.[0]?.type)) {
          toasts.error(t('project_edit.image_error.wrong_format'));
          failedChecks.size = true;
        }
    
        const {
          size: failedSize,
          dimensions: failedDimensions,
          ratio: failedRatio,
        } = failedChecks;
    
        if (failedSize || failedDimensions || failedRatio) {
          sipRef.current.uploader.inputRef.current.value = '';
          sipRefEn.current.uploader.inputRef.current.value = '';
    
          return false;
        }
    
        return true;
      }, [t]);

      const chaptersEdit = useMemo(() => {
        if (book) {
            return (
            <BookChaptersEdit
                bookId={book.bookId}
                chapters={chapters}
                setChapters={onChaptersAdd}
                setChapterIds={setChapterIds}
                isLoading={isLoading && !isHiddenLoading}
                canCreateChapter={canCreateChapter}
                getBookAuthorsIds={getBookAuthorIds}
                setIsAllChaptersPublished={setIsAllChaptersPublished}
                onCreateChapterClick={onCreateChapterClick}
                onSelectChaptersClick={onSelectChaptersClick}
                onChapterAdd={onChapterAdd}
                update={() => {setIsHiddenLoading(true);setTime(Date.now())}}
                disabled={isPaidBook}
            />
            )
        }
      }, [chapters, isPaidBook, isLoading, isHiddenLoading, book, canCreateChapter])
      

    const sip = useSimpleUploader(uploaderCallback, uploadValidator);
    const sip_en = useSimpleUploader(uploaderCallback, uploadValidator);

    sipRef.current = sip;
    sipRefEn.current = sip_en;

    const PortalPublish = useMemo(() => {
        const outer = document.getElementById('publish-button-container');
        if (!outer) {
            return null;
        }

        return createPortal(<QueueButtonFilled disabled={isPaymentButtonDisabled} onClick={openPaymentModal}>
                {t('card_constructor.nav.publish')}
            </QueueButtonFilled>,
            outer,
        );
    }, [
        additionalItems, activeCardIds, openPaymentModal, isPaymentButtonDisabled
    ]);
    
    if (isUpdateError) {
        return <BookEditFrameUpdateError id={id}/>;
    }

    if (isForbidden) {
        return <BookEditFrameForbidden id={id}/>;
    }

    if (isError) {
        return <Unavailable />;
    }

    if (isCreating) {
        return <BookEditFrameCreating id={id}/>;
    }

    if (!book || !profile || !book.bookId) {
        return <BookEditFrameLoading id={id}/>;
    }

    const custom = {
        customBackgroundColor: Colors.galBlack5,
        customBorderColor: 'transparent',
        customBorderColorHover: 'transparent',
        customTextColor: Colors.galBlack100,
        customPlaceholderColor: Colors.galBlack47,
        marginTop: isMobile ? 0 : 'auto',
        height: "fit-content"
    };

    return (
        <>
            <PageViewportLayout offsetTop={isMobile ? 0 : 40} offsetTopMobile={16}>
                {PortalMenu}
                <ProjectContainerLayout
                    isBookEdit
                    leftSide={
                        <BookImageContainer 
                            canCreateChapter={canCreateChapter}
                            onCreateChapterClick={onCreateChapterClick}
                            onSelectChaptersClick={onSelectChaptersClick}
                            book={book}
                            previewProject={previewProject || undefined}
                        />
                    } 
                    rightSide={
                        <ProjectEditPageContainer style={{ margin: isMobile ? '0 0 auto 0' : 'inherit'}}>
                        <BookTitleSectionOuter>
                            <ProjectTitleSection
                                customProps={custom}
                                projectTitle={Lang(bookTitle, i18n.language)}
                                setProjectTitle={onTitleChange}
                                isBookEdit
                                disabled={isPaidBook}
                                
                            />
                        </BookTitleSectionOuter>
                            <ProjectEditPageGrid>
                            {bookAndChaptersTags?.length > 0 && <ProjectEditPageGridRow className={'books-tags-wrap'} direction="column" gy={8} gyMobile={8}>
                                <ProjectEditPageGridLabel {...custom} className={'books-label'}>
                                    {t('book_edit.tags')}
                                </ProjectEditPageGridLabel>
                                <BookEditAddTagsContainer>
                                    <BTagsGridNew scrollMode="all" style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                    {bookAndChaptersTags.map((value: any) => (
                                        <BTag
                                            tag={value}
                                            educational={value.isEducationTag}
                                            organization={value.isTeamTag}
                                            isProjectsTag
                                            key={value.tagId}
                                        >
                                            {bTag.title(value)}
                                        </BTag>
                                    ))}
                                    </BTagsGridNew>
                                </BookEditAddTagsContainer>
                            </ProjectEditPageGridRow>}
                                {<ProjectEditPageGridRow className={'bilingual-container'} offsetTop={bookAndChaptersTags?.length > 0 ? 14 : 0} align={'center'}>
                                    <BilingWrapper >
                                        <FlexBox direction="row" directionMobile="row">
                                            <Input.Checkbox
                                                disabled={isPaymentTypeLoading || !BookDelegate.canChangePaymentType(book)}
                                                title={''}
                                                className={'competition-checkbox'}
                                                checked={!!isBookForSale}
                                                onChange={(value: any) => {
                                                    setIsProtected(!isBookForSale);
                                                    onUpdatePaymentType(!isBookForSale)
                                                }}
                                            />
                                            <FlexBox offsetLeft={8} offsetLeftMobile={8} align="center">
                                                <BilingLabel className="biling-label">{t('payment.book_for_sale')}</BilingLabel>
                                            </FlexBox>
                                        </FlexBox>
                                    </BilingWrapper>
                                </ProjectEditPageGridRow>
                                }
                                    <ProjectEditPageGridRow className={'bilingual-container'} offsetTop={bookAndChaptersTags?.length > 0 ? 14 : 0} align={'center'}>
                                        <ProtectSection 
                                            value={isBookForSale ? true : isProtected} 
                                            onChange={handleToggleProtectTypeClick} 
                                            customStyles={custom}
                                        />
                                    </ProjectEditPageGridRow>
                                <ProjectEditPageGridRow className={'bilingual-container'} offsetTop={bookAndChaptersTags?.length > 0 ? 14 : 0} align={'center'}>
                                    <Availability
                                        availability={availability}
                                        onChange={(val) => setAvailability(val)}
                                        onCopy={handleLinkCopy}
                                        direction="column"
                                    />
                                </ProjectEditPageGridRow>
                                {errorsArray?.length > 0 && <SectionBottom className={'errors-wrapper'}>
                                <FlexBox direction="column" directionMobile='column' offsetTop={47}>
                                <ErrorItem
                                    color={theme.projectEdit.textTips}
                                    direction="column"
                                    directionMobile="column"
                                >
                                    <ul>
                                    {errorsArray.filter((err) => err !== t('create.tips.fill')).map((error) => (
                                        <li>
                                        <FlexBox direction='row'>
                                            <span style={{ marginRight: 8 }}>{`—`}</span>
                                            <span>{`${error}`}</span>
                                        </FlexBox>
                                        </li>
                                    ))}
                                    </ul>
                                </ErrorItem>
                                {errorsArray.includes(t('create.tips.fill')) && (
                                    <FlexBox direction='row' directionMobile='row' offsetTop={16} offsetTopMobile={16}>
                                    <LabelRedStar style={{ marginLeft: 0 }}>*</LabelRedStar>
                                    <RequiredErrorMsg>{errorsArray[errorsArray.length -1 ]}</RequiredErrorMsg>
                                    </FlexBox>
                                )}
                                </FlexBox>
                            </SectionBottom>}

                        </ProjectEditPageGrid>
                    </ProjectEditPageContainer>
                    }
                />
                {book && <>
                    <ChaptersWrapper offsetTop={24}>
                       {chaptersEdit}
                    </ChaptersWrapper>
                    {(isBookForSale) && <ChaptersWrapper offsetTop={24}>
                        <QueueNew
                            currentQueuePoint={{number: 1, type: QueueCircleType.current}}
                            mode={isPaidBook ? QueueMode.view : QueueMode.create}
                            rate={QueueRate.high}
                            isBook
                            cardsLength={activeCardIds?.length || 0}
                            userQueuePoints={[]}/>
                    </ChaptersWrapper>}
                    {(isBookForSale) && <ChaptersWrapper offsetTop={24}>
                        <BookCards bookId={book?.bookId || ""} setIsCardsUpdateIsLoading={setIsCardsUpdateIsLoading} setActiveCardIds={setActiveCardIds} activeCardIds={activeCardIds} cards={additionalItems || []} disabled={isPaymentTypeLoading || !BookDelegate.canChangePaymentType(book)}/>
                    </ChaptersWrapper>}
                </>}
                {PortalPublish}
                <FlexBox offsetTop={200}/>
            </PageViewportLayout>
            <ScrollUpZone/>
        </>
    );
};
import { API, Book, BookAPI, Designer, Lang, Project, PageModel, ProjectAPI, Tag, UploadFileAPI, ProjectUtils, Endpoints, CurrencyType } from "@brg/api";
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { useProfile } from "@brg/auth";
import { Colors, FInter, FlexBox, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { bTag, LayoutConst, useModal } from "core";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import { CreateLinkTo } from "shared/constants/linkTo";
import { convertDesignerFromGlobalToLocal } from "shared/pages/projectEdit/utils";
import { createPortal } from "react-dom";
import { NavbarCreate } from "shared/components/navbar-elements";
import { BookEditFrameCreating, BookEditFrameError, BookEditFrameForbidden, BookEditFrameLoading, BookEditFrameUpdateError } from "_deziiign/books/core/components/error-frames/book-edit-frames";
import { PageViewportLayout, ProjectContainerLayout } from "shared/components/template";
import { ScrollUpZone } from "shared/components/__FOX__/NAV/src/scroll-up-zone";
import { ProjectEditPageContainer, ProjectEditPageGrid, ProjectEditPageGridLabel, ProjectEditPageGridRow } from "shared/pages/projectEdit/styles";
import ProjectTitleSection from "shared/pages/projectEdit/ProjectTitleSection";
import { LabelRedStar, QueueButtonFilled} from "shared/pages/designerEditView/styles";
import { BTag } from "core/components";
import styled, { useTheme } from "styled-components";
import { BookDelegate } from "_deziiign/books/core/book-delegate";
import { BookEditAddTagsContainer, BookTitleSectionOuter } from "./styles";
import { BookChaptersEdit } from "./BookChaptersEdit/BookChaptersEdit";
import { BookImageContainer } from "./BookChaptersEdit/BookImageContainer";
import { useSimpleUploader } from "@brg/uploader";
import axios, { AxiosResponse } from "axios";
import {BookCards} from "./components/BookCards/BookCards";
import {
    useGetAdditionalBookItems,
} from "../../../../shared/hooks/api/Shop/useGetAdditionalItems";
import {QueueMode, QueueNew} from "../../../../shared/features/QueuePaymenrt/components/Queue/New/QueueNew";
import {
    QueueCircleType,
    QueueRate
} from "../../../../shared/features/QueuePaymenrt/components/Queue/New/components/QueueLineNew/QueueLineNew";
import {
    clearOrderFields,
    goToStep, selectorOrder,
    setFlowType,
    setImmediatePurchaseProps
} from "../../../../shared/features/QueuePaymenrt/slices/OrderSlice";
import {FlowType} from "../../../../shared/features/QueuePaymenrt/constants/flowType";
import {useDispatch, useSelector} from "react-redux";
import {EntityPaymentTypes} from "../../../../shared/features/QueuePaymenrt/constants/payment";
import {bookFlowSteps } from "../../../../shared/features/QueuePaymenrt/payment/Flows";
import {Input} from "@brg/input";
import {BilingLabel, BilingWrapper} from "../../../../shared/pages/projectEdit/styles";
import {useBookCard} from "../../../../shared/hooks/api/Book/useBookCard";
import {UpsertBookData} from "../../../../shared/actions/Book/UpsertBookData";
import { Availability } from "shared/pages/projectEdit/components/Availability/Availability";
import { AvailabilityAction } from "shared/pages/projectEdit/types";
import { copyLinkProject } from "shared/helpers/copyLink";
import { ProtectSection } from "./sections/ProtectSection";
import { protectStatuses } from "shared/helpers/protectStatus";
import {BTagsGridNew} from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import Unavailable from "shared/pages/unavailable";
import { DRAFT_STATUS } from "shared/pages/projectEdit/constants";

const MAX_FILE_SIZE = 157286400;

const ChaptersWrapper = styled(FlexBox)`

    @media (max-width: ${LayoutConst.screen.mac13 + 1}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin: 24px auto;
        width: 888px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      justify-content: center;
        //margin: 16px 6.6vw 0;
        margin: 16px 0 0 0;
        width: auto;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        margin: 24px 10px 0;
    }
`;

const SectionBottom = styled(FlexBox)`
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const ErrorItem = styled(FInter.SmallTextFlex)`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  display: flex;
  align-items: baseline;
  color: #909090;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`;

const RequiredErrorMsg = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #909090;
  white-space: nowrap;
  padding-left: 4px;
`;

enum DnDHelp {
    Initialization = "INITIALIZATION",
    Wait = "WAIT",
    Showed = "SHOWED"
}

export enum PaymentStatus {
    Free = 0,
    PayBook = 1,
}

interface MobileInputsState {
    coAuthor: boolean;
    publisher: boolean;
    bibliography: boolean;
}

interface BookEditProps {
    className?: any;
}

const BOOK_DRAFT_TAB_POSTFIX = "?tab=draft_books"

export const MINIMUM_CARDS_FOR_QUEUE = 1

export const BookEdit: FC<BookEditProps> = ({ className }) => {
    const { t, i18n } = useTranslation();
    const toasts = useToasts();
    const profile = useProfile();
    const { id } = useParams<{ id: string }>();
    const throttle = useRef<any>();
    const history = useHistory();
    const isMobile = useIsMobile();
    const modal = useModal();
    const theme = useTheme();
    const dispatch = useDispatch();
    
    const [isCreating, setIsCreating] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isForbidden, setIsForbidden] = useState(false);
    const [isUpdateError, setIsUpdateError] = useState(false);
    const { activeTariff } = useSelector(selectorOrder)

    const [isChaptersUpdateLoading, setIsChaptersUpdateIsLoading] = useState<boolean>(false);
    const [isCardsUpdateLoading, setIsCardsUpdateIsLoading] = useState<boolean>(false);
    const isPaymentUpdateLoading = useMemo(() => isCardsUpdateLoading || isChaptersUpdateLoading, [isCardsUpdateLoading, isChaptersUpdateLoading])

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isHiddenLoading, setIsHiddenLoading] = useState<boolean>(false);
    const [isBookForSale, setIsBookForSale] = useState<boolean>(false);
    const [isPaymentTypeLoading, setIsPaymentTypeLoading] = useState<boolean>(false);
    const [time, setTime] = useState(Date.now());
    const [book, setBook] = useState<Book<'Global'> & any>();
    const [bookTitle, setBookTitle] = useState<LangObject[]>([]);
    const [bookCoAuthors, setBookCoAuthors] = useState<Designer[]>([]);
    const [bookTags, setBookTags] = useState<Tag[]>([]);
    const [chaptersTags, setChaptersTags] = useState<Tag[]>([])
    const [bibliography, setBibliography] = useState<string>("");
    const [publisher, setPublisher] = useState<string>("");
    const [bookStatus, setBookStatus] = useState<number>(0);
    const [isAllChaptersPublished, setIsAllChaptersPublished] = useState<boolean>(false);
    const [chapters, setChapters] = useState<Project[]>([]);
    const [chapterIds, setChapterIds] = useState<string[]>([]);
    const [chapterLongreadsPostCount, setChapterLongreadsPostCount] = useState<number[]>([]);
    const [isTooltipShowed, setIsTooltipShowed] = useState(false);
    const [availability, setAvailability] = useState<string>(AvailabilityAction.open);
    // @ts-ignore
    const chapterHasCover = useCallback((chapter) => !!ProjectUtils.getTitleImageOrUndefined(chapter), [chapters]);
    const [activeCardIds, setActiveCardIds] = useState<string[]>([]);
    const [isProtected, setIsProtected] = useState(false);
    const isPaidBook = useMemo(() => BookDelegate.isPaid(book), [book])

    const [additionalItems] = useGetAdditionalBookItems(id, isPaidBook, time)
    useEffect(() => {
        setActiveCardIds(additionalItems?.filter((item: any) => item?.isForPay && item?.printQuality !== 'A5')?.map((item: any) => item?.itemId))
    }, [additionalItems])
    useEffect(() => {
        setIsBookForSale(book?.paymentType === PaymentStatus.PayBook)
        setIsPaymentTypeLoading(false)
    }, [book?.paymentType])

    const onChaptersAdd = useCallback((chapters: any) => {
        setChapters(chapters)
    } , [])

    const bookAndChaptersTags = useMemo(() => {
        const uniqueMap = new Map<string, Tag>();
        [...bookTags, ...chaptersTags].forEach((item) => {
          uniqueMap.set(item.tagId, item);
        });
        return Array.from(uniqueMap.values());
    } , [bookTags, chaptersTags, isLoading])

    const errorsArray = useMemo(() => {
        const errors = [];

        if (isLoading && !isHiddenLoading) return []

        if (chapters.length === 0) {
            errors.push(t('create.tips.book_no_chapters'));
        }

        let uncompletedChapters: number[] = []

        chapters.forEach((chapter, idx) => {
            if (chapter.title.length === 0 || !chapterHasCover(chapter) || chapter.tagsID.length === 0 || chapterLongreadsPostCount[idx] === 0) {
                uncompletedChapters.push(idx+1)
            }
        })

        if (uncompletedChapters.length > 0) {
            if (uncompletedChapters.length > 1) {
                errors.push(t('create.tips.book_chapters_uncomplete', {
                    chapters: uncompletedChapters.join(", ")
                }));
            } else {
                errors.push(t('create.tips.book_chapter_uncomplete', {
                    chapter: uncompletedChapters[0]
                }));
            }
        }

        if (Lang(bookTitle, i18n.language).replaceAll(" ", "").length === 0 || bookAndChaptersTags.length === 0) {
            errors.push(t('create.tips.fill'))
        }

        if (!bookAndChaptersTags.find((tag) => tag.isEducationTag)) {
            errors.push(t('create.tips.educational_tags_not_enough'));
        }

        return errors;
      }, [chapters, chapterIds, bookTitle, i18n, isLoading, isHiddenLoading, bookAndChaptersTags, chapterLongreadsPostCount])

    const inputsRef = useRef<any>(null);
    
    const [inputsState, setInputsState] = useState<MobileInputsState>({
        coAuthor: false,
        publisher: false,
        bibliography: false
    })

    const [statusText, setStatusText] = useState('');
    const [isSending] = useState(false);
    const [statusDnDHelp, setStatusDnDHelp] = useState<DnDHelp>(DnDHelp.Initialization); 

    const projectIdRef = useRef<any>(null);
    const langRef = useRef<any>(null);
    const bilingualRef = useRef<any>(null);
    const sipRef = useRef<any>(null);
    const sipRefEn = useRef<any>(null);

    projectIdRef.current = id;

    const primaryButtonText = useMemo(() => (
        bookStatus === 0
            ?   t('nav.publish')
            :   t('save')
    ), [bookStatus, t]);

    const previewProject = useMemo(() => (chapters?.length > 0 && chapters?.[0]), [chapters])

    const fetchLongreadsPostCount = async () => {
        const longreadsPostCount = await Promise.all(chapterIds.map(async (chapterId) => {
            const longreadPosts: AxiosResponse<any[]> = await axios.get(`${Endpoints.longread}/api/post/GetMany?idLongread=${chapterId}`)
            return longreadPosts.data.length
        }))
        setChapterLongreadsPostCount(longreadsPostCount)
        return longreadsPostCount
    }

    const onUpdatePaymentType = useCallback((isBookForSale: boolean) => {

        if (isPaymentTypeLoading) return;

        setIsPaymentTypeLoading(true)
        API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/Book/UpdatePaymentType`)
            .post()
            .body({
                bookId: book?.bookId,
                paymentType: isBookForSale ? PaymentStatus.PayBook : PaymentStatus.Free,
            })
            .send()
            .then(() => {
                setIsBookForSale(isBookForSale)
                setIsPaymentTypeLoading(false)
            });
    }, [book, isPaymentTypeLoading]);

    const bookCards = useMemo(() => additionalItems?.filter((item: any) => activeCardIds?.includes(item?.itemId)) || [], [additionalItems, activeCardIds])

    const {
        cardId: bookCardId,
        isLoading: isBookCardLoading,
        error: bookCardError
    } = useBookCard(book?.bookId || "", !isBookForSale || isLoading || isHiddenLoading)

    const handleLinkCopy = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        copyLinkProject(book?.bookId, toasts, t);
    };


    useEffect(() => {
        fetchLongreadsPostCount()
    }, [chapterIds])
    useEffect(() => {
        UpsertBookData(book?.bookId || "", { chapterIds }, setIsChaptersUpdateIsLoading, dispatch)
    }, [book?.bookId, chapterIds])

    useEffect(() => {
        if (profile) {
            if (id) {
                BookAPI.Get({ id: id })
                    .then((value) => value.json() as Promise<Book<'Global'>>)
                    .then((value) => {
                        if (value.bookId) {
                            setBook(value);
                            setIsError(false);
                            const projectAvailability = value.status === 10 ? AvailabilityAction.link : AvailabilityAction.open;
                            setAvailability(projectAvailability);
                            if (!BookDelegate.canEdit(profile, value)) {
                                setIsForbidden(true);
                            }
                        } else {
                            setBook(undefined);
                            setIsError(true);
                        }
                    })
                    .catch((reason) => {
                        setBook(undefined);
                        setIsError(true);
                    });
            } else {
                setIsCreating(true);
                BookAPI.Add({
                        title: createDefaultLangObject(''),
                        status: 0
                    } as Book<'Global'> & any)
                    .then((res) => res.json())
                    .then((res: any) => {
                        setTimeout(() => {
                            setIsCreating(false);
                            history.replace(CreateLinkTo.bookEdit(res));
                        }, 800);
                    });
            }
        }
    }, [id, profile, history, time]);

    useEffect(() => {
        if (profile && book && book.bookId) {
            setBookTitle(book.title);
            setBookStatus(book.status);
        }
    }, [profile, book])

    useEffect(() => {
        if (profile && book && book.bookId) {

            const coAuthors = (book.coAuthors || []) as Designer<'Global'>[];

            setBookCoAuthors(coAuthors.map((author) => convertDesignerFromGlobalToLocal(author, i18n.language)));

            const currentTags = [...book.tags].map((tag) => {
                const translatedTag = API.toLang<Tag>(tag, i18n.language);
                return {
                    ...translatedTag,
                }
            });

            setBookTags(currentTags);

            setBibliography(book.bibliographyLink);
            setPublisher(book.publisher);

            setIsProtected(book.isProtected)
        }

    }, [profile, book]);

    useEffect(() => {
        if (book && book.bookId) {
            if (throttle.current) {
                clearTimeout(throttle.current);
                throttle.current = null;
            }

            setStatusText(t('saving'));

            throttle.current = setTimeout(() => {
                if (book && book.bookId) {
                    const copy: Book<'Global'> = { ...book };

                    copy.title = bookTitle;
                    copy.coAuthorIds = bookCoAuthors.map((value) => value.accountId);
                    copy.tagIds = bookAndChaptersTags.map((value) => value.tagId);
                    copy.bibliographyLink = bibliography;
                    copy.publisher = publisher;

                    copy.isProtected = isBookForSale ? true : isProtected

                    BookAPI.Update(copy)
                        .then(() => {
                            setTimeout(() => setStatusText(t('saved')), 1000);
                            if (isSending) {
                                history.push(CreateLinkTo.book(book.bookId));
                            }
                        })
                        .catch(() => setIsUpdateError(true));
                }
            }, 1000);
        } else {
            setStatusText('Loading book...');
        }
    }, [
        history,
        isSending,
        profile,
        chapters,
        book,
        bookTitle,
        isProtected,
        isBookForSale,
        bookCoAuthors,
        bookAndChaptersTags,
        bookStatus,
        bibliography,
        publisher,
        id,
        t,
    ]);

    useEffect(() => {
        if (inputsState?.publisher || inputsState?.bibliography ) {
          inputsRef?.current?.focus()
        }
      },[inputsState])
    
      useEffect(() => {
        if (book) {
            setIsLoading(true);
            ProjectAPI.GetList({
                    bookId: book?.bookId,
                    projectFilter: 8,
                    isLite: false,
                    isContextIgnored: true
                })
                .then(v => v.json())
                .then((v) => API.toLang<PageModel<Project>>(v, i18n.language))
                .then((v) => {
                    let count = 0;
                    if (v?.data) {
                        count = v.data.length;
                        setChapters(v.data);
                        setIsTooltipShowed(v.data?.length >= 2);
                        setChapterIds(v.data.map(x => x.projectId));
                        setIsAllChaptersPublished(count > 0 && !v.data.some(x => x.status !== 1 && x.status !== 6));
                        const allTags = v.data.flatMap(x => x.tags);
                        const exptCategoryTags = allTags?.filter((i) => i?.level === 0);
                        setChaptersTags(exptCategoryTags);
                        
                    } else {
                        setChapters([]);
                        setChapterIds([]);
                        setIsAllChaptersPublished(false);
                    }
                    setIsLoading(false);
                    setIsHiddenLoading(false);
    
                    switch (statusDnDHelp) {
                        case DnDHelp.Initialization:
                            setStatusDnDHelp(count >= 2 ? DnDHelp.Showed : DnDHelp.Wait);
                            break;
                        case DnDHelp.Wait:
                            if (count >= 2) {
                                setStatusDnDHelp(DnDHelp.Showed);
                            }
                            break;
                        default:
                            break;
                    }
                });
        }
    }, [book, time, i18n]);

    const getRedirectIfBackClick = useCallback(() => {

        const moveToDrafts = !chapterIds?.length || 
            !chapterLongreadsPostCount?.length ||
            bookTitle?.every((i) => i.name === '') || 
            !bookAndChaptersTags?.length ||
            !bookAndChaptersTags?.find((i) => i?.isEducationTag) ||
            !!errorsArray?.length
        ;
            
        if (moveToDrafts) {
             BookAPI.UpdateStatus({
                bookStatus: DRAFT_STATUS,
                bookId: book?.bookId,
            })
        }

        profile && book && book.status === 0
            ? history.push(CreateLinkTo.designerNew(profile) + BOOK_DRAFT_TAB_POSTFIX)
            : history.replace(CreateLinkTo.book(book?.bookId ?? "undefined"))
    }, [book, history, profile, bookTitle, errorsArray, chapterIds, chapterLongreadsPostCount,  bookAndChaptersTags]);

    const updateChaptersProtectStatus = useCallback( async(ids: string[]) => {
        return await Promise.all(ids?.map(async(id) => (
            await API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/Project/Protect`)
            .post()
            .body({
              projectId: id ?? '',
              action: protectStatuses[isProtected? 'enabled' : 'disabled']
            })
            .send()
        )))
    } , [isProtected])

    const onPublish = useCallback((): void => {
        // получаем актуальные данные о главах
        if (profile && book) {
            ProjectAPI.GetList({
                bookId: book?.bookId,
                projectFilter: 8,
                isLite: false,
                isContextIgnored: true
            })
            .then(v => v.json())
            .then((v) => API.toLang<PageModel<Project>>(v, i18n.language))
            .then(async (v) => {
                const chapterLongreadsPostCount = await fetchLongreadsPostCount()
                return {
                    chapters: v.data,
                    chapterLongreadsPostCount
                }
            })
            .then(info => {
                const canPublish = BookDelegate.canPublish(profile, book, Lang(bookTitle, i18n.language), bookAndChaptersTags, info.chapters, info.chapterLongreadsPostCount);

                if (canPublish) {
                    setStatusText(t('save'));
                    BookAPI.UpdateStatus({
                        bookStatus: availability === AvailabilityAction.link ? 10 : 1,
                        bookId: id,
                    }).then(() => {

                        if (!!info.chapters?.length) {
                            updateChaptersProtectStatus(
                                info.chapters?.map((chapter) => chapter?.projectId)
                            )
                            .then((r) => {
                                if (r?.every((response) => !!response?.ok)) {
                                    history.push(CreateLinkTo.book(book.bookId));
                                } else {
                                    toasts.error(t("book_edit.chapters_updated_error"))
                                }
                            })  
                        } else {
                            history.push(CreateLinkTo.book(book.bookId));
                        }

                    });
                } else {
                    toasts.error(t("book_edit.chapters_updated_error"))
                }
            })
        }
    }, [history, id, profile, book, t, chapters, bookTitle, bookAndChaptersTags, availability, chapterLongreadsPostCount, isProtected]);


    const onProtectAfterPayment = useCallback(() => {
        if (!!chapterIds?.length) {
            updateChaptersProtectStatus(chapterIds)  
        } 
    } , [chapterIds, isProtected])

    const goToSuccess = useCallback(() => {
        modal.hide()
        onProtectAfterPayment()
        modal.show("bookPaymentSuccess", {
            products: [book],
            containerStyles: {
                background: 'rgba(231,231,231, 0.90)',
                backdropFilter: 'none'
            },
            onCustomClose: () => {
                window.open(CreateLinkTo.book(book?.bookId), '_SELF');
            }
        })
    }, [modal, book, onProtectAfterPayment])

    const openPaymentModal = useCallback(async () => {
        try {
            if (!profile) {
                toasts.error("You need to login")
                return
            }
            if (!book?.bookId) return
            const translatedBook = API.toLang(book, i18n.language) as Book<'Local'>;

            await dispatch(setFlowType(FlowType.BUY_BOOK))
            dispatch(setImmediatePurchaseProps({
                productId: bookCardId,
                paymentEntityType: EntityPaymentTypes.book,
                flowType: FlowType.BUY_BOOK,
                currencyType: CurrencyType.RealMoney,
                preventGetCurrencies: true,
                tariff: activeTariff,
                bookId: book?.bookId,
                price: activeTariff?.creatingPrice || 0,
                productInfo: {
                    name: bookTitle || translatedBook?.title || "",
                    // @ts-ignore
                    preview: previewProject?.titleImages || translatedBook?.titleImages,
                    price: activeTariff?.creatingPrice || 0,
                    type: EntityPaymentTypes.book,
                    cardInfo: bookCards
                }
            }))
            modal.show("paymentManager", {
                containerStyles: {
                    background: 'rgba(231,231,231,1)',
                    backdropFilter: 'none'
                },
                flowType: FlowType.BUY_BOOK,
                onPaymentSuccess: () => goToSuccess(),
                onPaymentFail: () => {
                    dispatch(goToStep(bookFlowSteps.errorPayment)) },
                cancel: () => { dispatch(clearOrderFields()) },
            })
        } catch (err) {
            toasts.error(`${t('messages.something_went_wrong')}. ${t('try_later')}.`)
            console.error('openPaymentModal err:', err);
        }
    }, [dispatch, book, activeTariff, activeCardIds, goToSuccess, bookCardId, bookCards, previewProject])

    const previewButtonClick = useCallback(() => history.push(CreateLinkTo.bookPreview(id)), [history, id]);
    const isReadyToPublish = useMemo(() => BookDelegate.canPublish(profile, book, Lang(bookTitle, i18n.language), bookAndChaptersTags, chapters, chapterLongreadsPostCount), [profile, book, bookTitle, i18n.language, bookAndChaptersTags, chapters, chapterLongreadsPostCount])
    const isPaymentButtonDisabled = useMemo(() => (activeTariff?.creatingPrice === 0 || isBookCardLoading || isPaymentUpdateLoading || isSending || activeCardIds?.length < MINIMUM_CARDS_FOR_QUEUE || !isBookForSale || !isReadyToPublish || !BookDelegate.canChangePaymentType(book)), [activeTariff, isBookCardLoading, isSending, isReadyToPublish, isBookForSale, activeCardIds, book, isPaymentUpdateLoading])

    const PortalMenu = useMemo(() => {
        const outer = document.getElementById('navbar-portal');
        if (!outer) {
            return null;
        }

        return createPortal(
            <NavbarCreate
                className={className}
                status={bookStatus}
                isReadyToNext={!isSending}
                primaryButtonEnabled={(isBookForSale && bookStatus !== 1) ? !isPaymentButtonDisabled : isReadyToPublish}
                primaryButtonText={primaryButtonText}
                projectName={Lang(bookTitle, i18n.language)}
                stateText={statusText}
                onSecondaryClick={getRedirectIfBackClick}
                onPrimaryClick={(isBookForSale && bookStatus !== 1) ? openPaymentModal : onPublish}
                onPreviewClick={previewButtonClick}
                errors={errorsArray}
            />,
            outer,
        );
    }, [
        chapters,
        profile,
        className,
        bookTitle,
        bookAndChaptersTags,
        errorsArray,
        chapterLongreadsPostCount,
        statusText,
        bookStatus,
        isBookForSale,
        isReadyToPublish,
        isPaymentButtonDisabled,
        openPaymentModal,
        onPublish,
        getRedirectIfBackClick,
        previewButtonClick,
        i18n,
        primaryButtonText,
        isSending,
    ]);

    const onTitleChange = (value: string) => {
        setBookTitle(createDefaultLangObject(value));
    }

    const getBookStatus = useCallback((): number => {
        return bookStatus;
    }, [bookStatus]);

    const getBookAuthorIds = useCallback((): string[] => {
        if (book && book.authorId) {
            return [ ...bookCoAuthors.map(x => x.accountId), book.authorId ];
        }
        return bookCoAuthors.map(x => x.accountId);
    }, [book, bookCoAuthors]);

    const canCreateChapter = useMemo(() => {
        const bookStatus = getBookStatus();
        return bookStatus !== 1 && bookStatus !== 6 && statusText === t('saved')
    }, [getBookStatus, statusText, t]);

    const onCreateChapterClick = useCallback(() => {
        if (!canCreateChapter) {
            return;
        }
        history.push(CreateLinkTo.bookProjectCreate(book?.bookId));
    }, [book, history, canCreateChapter]);

    const onChapterDelete = useCallback((projectId: string) => {
        ProjectAPI.RemoveBookInfo({
                bookChapterNumber: 0,
                bookId: book?.bookId,
                projectId: projectId,
            })
            .then(() => {
                setTime(Date.now());
            });
    }, [book]);


    const onChapterAdd = useCallback((projectId: string, isFirst?: boolean, isMultiple?: boolean) => {
        ProjectAPI.AddBookInfo({
                bookChapterNumber: 0,
                bookId: book?.bookId,
                projectId: projectId,
            })
            .then(() => {
                if ((chapters?.length >= 1 || isMultiple) && isFirst && !isTooltipShowed) {
                    setIsTooltipShowed(true);
                    toasts.info(t('book_edit.chapters.dnd_info'));
                }
                setTime(Date.now());
            });
    }, [book, chapters, isTooltipShowed]);

    const onSelectChaptersClick = useCallback(() => {
        if (isPaidBook) return;

        const chapterIds = chapters?.filter((i) => {
            return i?.authorId === profile?.accountId || i?.coAuthorIds?.includes(profile?.accountId ?? '')
        })
        modal.show('select-chapters', {
            projectIds: chapterIds?.map((i) => i?.projectId),
            authorsIds: profile?.accountId,
            bookStatus: getBookStatus(),
            bookId: book?.bookId,
            onSelect: onChapterAdd,
            onUnSelect: onChapterDelete
        });
    }, [modal, book, profile, chapters, getBookAuthorIds, getBookStatus, onChapterAdd, onChapterDelete, isPaidBook]);

    const handleToggleProtectTypeClick = useCallback((val: boolean) => {
        if (isBookForSale) {
            toasts.error(t('book_edit.frames.book_default_protect'));
            return;
        }

        setIsProtected(val)
    } , [isBookForSale, toasts])

    // @ts-ignore
    const uploaderCallback = useCallback((fileId) => {
        if (!fileId) {
          return null;
        }
    
        UploadFileAPI.Upload({
          fileId,
          profileId: projectIdRef.current,
          service: 'geography',
          entityType: 'projectimage',
          ...(bilingualRef.current === true ? {
            localization: langRef.current,
          } : {})
        }).then((res) => {
          sipRef.current.uploader.uploader.uppy.reset();
          return res;
        });
      }, [projectIdRef])
      const uploadValidator = useCallback(async (files: any) => {
        let failedChecks: {
          dimensions?: boolean;
          size?: boolean;
          ratio?: boolean;
          type?: boolean;
        } = {};
        const loadFile = () => new Promise((resolve, reject) => {
          const fr = new FileReader();
          fr.onload = function () { // file is loaded
            const img = new Image();
    
            img.onload = function () {
              const {
                width,
                height,
              } = img;
              resolve({
                width,
                height,
              })
            };
    
            //@ts-ignore
            img.src = fr.result; // is the data URL because called with readAsDataURL
          };
          fr.readAsDataURL(files[0]);
        })
    
        //@ts-ignore
        const { height, width } = await loadFile();
    
        if (height > 5262 || width > 3720) {
          toasts.error(t('project_edit.image_error.max_width_height'));
          failedChecks.dimensions = true;
        }
    
        const ratio = width / height;
        if (ratio < 0.6 || ratio > 0.8) {
          toasts.error(t('project_edit.image_error.wrong_orientation'));
          failedChecks.ratio = true;
        }
    
        if (files?.[0]?.size > MAX_FILE_SIZE) {
          toasts.error(t('project_edit.image_error.max_size'));
          failedChecks.size = true;
        }
    
        if (!['image/jpeg'].includes(files?.[0]?.type)) {
          toasts.error(t('project_edit.image_error.wrong_format'));
          failedChecks.size = true;
        }
    
        const {
          size: failedSize,
          dimensions: failedDimensions,
          ratio: failedRatio,
        } = failedChecks;
    
        if (failedSize || failedDimensions || failedRatio) {
          sipRef.current.uploader.inputRef.current.value = '';
          sipRefEn.current.uploader.inputRef.current.value = '';
    
          return false;
        }
    
        return true;
      }, [t]);

      const chaptersEdit = useMemo(() => {
        if (book) {
            return (
            <BookChaptersEdit
                bookId={book.bookId}
                chapters={chapters}
                setChapters={onChaptersAdd}
                setChapterIds={setChapterIds}
                isLoading={isLoading && !isHiddenLoading}
                canCreateChapter={canCreateChapter}
                getBookAuthorsIds={getBookAuthorIds}
                setIsAllChaptersPublished={setIsAllChaptersPublished}
                onCreateChapterClick={onCreateChapterClick}
                onSelectChaptersClick={onSelectChaptersClick}
                onChapterAdd={onChapterAdd}
                update={() => {setIsHiddenLoading(true);setTime(Date.now())}}
                disabled={isPaidBook}
            />
            )
        }
      }, [chapters, isPaidBook, isLoading, isHiddenLoading, book, canCreateChapter])
      

    const sip = useSimpleUploader(uploaderCallback, uploadValidator);
    const sip_en = useSimpleUploader(uploaderCallback, uploadValidator);

    sipRef.current = sip;
    sipRefEn.current = sip_en;

    const PortalPublish = useMemo(() => {
        const outer = document.getElementById('publish-button-container');
        if (!outer) {
            return null;
        }

        return createPortal(<QueueButtonFilled disabled={isPaymentButtonDisabled} onClick={openPaymentModal}>
                {t('card_constructor.nav.publish')}
            </QueueButtonFilled>,
            outer,
        );
    }, [
        additionalItems, activeCardIds, openPaymentModal, isPaymentButtonDisabled
    ]);
    
    if (isUpdateError) {
        return <BookEditFrameUpdateError id={id}/>;
    }

    if (isForbidden) {
        return <BookEditFrameForbidden id={id}/>;
    }

    if (isError) {
        return <Unavailable />;
    }

    if (isCreating) {
        return <BookEditFrameCreating id={id}/>;
    }

    if (!book || !profile || !book.bookId) {
        return <BookEditFrameLoading id={id}/>;
    }

    const custom = {
        customBackgroundColor: Colors.galBlack5,
        customBorderColor: 'transparent',
        customBorderColorHover: 'transparent',
        customTextColor: Colors.galBlack100,
        customPlaceholderColor: Colors.galBlack47,
        marginTop: isMobile ? 0 : 'auto',
        height: "fit-content"
    };

    return (
        <>
            <PageViewportLayout offsetTop={isMobile ? 0 : 40} offsetTopMobile={16}>
                {PortalMenu}
                <ProjectContainerLayout
                    isBookEdit
                    leftSide={
                        <BookImageContainer 
                            canCreateChapter={canCreateChapter}
                            onCreateChapterClick={onCreateChapterClick}
                            onSelectChaptersClick={onSelectChaptersClick}
                            book={book}
                            previewProject={previewProject || undefined}
                        />
                    } 
                    rightSide={
                        <ProjectEditPageContainer style={{ margin: isMobile ? '0 0 auto 0' : 'inherit'}}>
                        <BookTitleSectionOuter>
                            <ProjectTitleSection
                                customProps={custom}
                                projectTitle={Lang(bookTitle, i18n.language)}
                                setProjectTitle={onTitleChange}
                                isBookEdit
                                disabled={isPaidBook}
                                
                            />
                        </BookTitleSectionOuter>
                            <ProjectEditPageGrid>
                            {bookAndChaptersTags?.length > 0 && <ProjectEditPageGridRow className={'books-tags-wrap'} direction="column" gy={8} gyMobile={8}>
                                <ProjectEditPageGridLabel {...custom} className={'books-label'}>
                                    {t('book_edit.tags')}
                                </ProjectEditPageGridLabel>
                                <BookEditAddTagsContainer>
                                    <BTagsGridNew scrollMode="all" style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                    {bookAndChaptersTags.map((value: any) => (
                                        <BTag
                                            tag={value}
                                            educational={value.isEducationTag}
                                            organization={value.isTeamTag}
                                            isProjectsTag
                                            key={value.tagId}
                                        >
                                            {bTag.title(value)}
                                        </BTag>
                                    ))}
                                    </BTagsGridNew>
                                </BookEditAddTagsContainer>
                            </ProjectEditPageGridRow>}
                                {<ProjectEditPageGridRow className={'bilingual-container'} offsetTop={bookAndChaptersTags?.length > 0 ? 14 : 0} align={'center'}>
                                    <BilingWrapper >
                                        <FlexBox direction="row" directionMobile="row">
                                            <Input.Checkbox
                                                disabled={isPaymentTypeLoading || !BookDelegate.canChangePaymentType(book)}
                                                title={''}
                                                className={'competition-checkbox'}
                                                checked={!!isBookForSale}
                                                onChange={(value: any) => {
                                                    setIsProtected(!isBookForSale);
                                                    onUpdatePaymentType(!isBookForSale)
                                                }}
                                            />
                                            <FlexBox offsetLeft={8} offsetLeftMobile={8} align="center">
                                                <BilingLabel className="biling-label">{t('payment.book_for_sale')}</BilingLabel>
                                            </FlexBox>
                                        </FlexBox>
                                    </BilingWrapper>
                                </ProjectEditPageGridRow>
                                }
                                    <ProjectEditPageGridRow className={'bilingual-container'} offsetTop={bookAndChaptersTags?.length > 0 ? 14 : 0} align={'center'}>
                                        <ProtectSection 
                                            value={isBookForSale ? true : isProtected} 
                                            onChange={handleToggleProtectTypeClick} 
                                            customStyles={custom}
                                        />
                                    </ProjectEditPageGridRow>
                                <ProjectEditPageGridRow className={'bilingual-container'} offsetTop={bookAndChaptersTags?.length > 0 ? 14 : 0} align={'center'}>
                                    <Availability
                                        availability={availability}
                                        onChange={(val) => setAvailability(val)}
                                        onCopy={handleLinkCopy}
                                        direction="column"
                                    />
                                </ProjectEditPageGridRow>
                                {errorsArray?.length > 0 && <SectionBottom className={'errors-wrapper'}>
                                <FlexBox direction="column" directionMobile='column' offsetTop={47}>
                                <ErrorItem
                                    color={theme.projectEdit.textTips}
                                    direction="column"
                                    directionMobile="column"
                                >
                                    <ul>
                                    {errorsArray.filter((err) => err !== t('create.tips.fill')).map((error) => (
                                        <li>
                                        <FlexBox direction='row'>
                                            <span style={{ marginRight: 8 }}>{`—`}</span>
                                            <span>{`${error}`}</span>
                                        </FlexBox>
                                        </li>
                                    ))}
                                    </ul>
                                </ErrorItem>
                                {errorsArray.includes(t('create.tips.fill')) && (
                                    <FlexBox direction='row' directionMobile='row' offsetTop={16} offsetTopMobile={16}>
                                    <LabelRedStar style={{ marginLeft: 0 }}>*</LabelRedStar>
                                    <RequiredErrorMsg>{errorsArray[errorsArray.length -1 ]}</RequiredErrorMsg>
                                    </FlexBox>
                                )}
                                </FlexBox>
                            </SectionBottom>}

                        </ProjectEditPageGrid>
                    </ProjectEditPageContainer>
                    }
                />
                {book && <>
                    <ChaptersWrapper offsetTop={24}>
                       {chaptersEdit}
                    </ChaptersWrapper>
                    {(isBookForSale) && <ChaptersWrapper offsetTop={24}>
                        <QueueNew
                            currentQueuePoint={{number: 1, type: QueueCircleType.current}}
                            mode={isPaidBook ? QueueMode.view : QueueMode.create}
                            rate={QueueRate.high}
                            isBook
                            cardsLength={activeCardIds?.length || 0}
                            userQueuePoints={[]}/>
                    </ChaptersWrapper>}
                    {(isBookForSale) && <ChaptersWrapper offsetTop={24}>
                        <BookCards bookId={book?.bookId || ""} setIsCardsUpdateIsLoading={setIsCardsUpdateIsLoading} setActiveCardIds={setActiveCardIds} activeCardIds={activeCardIds} cards={additionalItems || []} disabled={isPaymentTypeLoading || !BookDelegate.canChangePaymentType(book)}/>
                    </ChaptersWrapper>}
                </>}
                {PortalPublish}
                <FlexBox offsetTop={200}/>
            </PageViewportLayout>
            <ScrollUpZone/>
        </>
    );
};
